import React, { useEffect, useMemo } from "react";
import styles from "./style.module.css";
import { useDispatch, useSelector } from "react-redux";
import { getBrandPageInfo } from "../../store/MainSlice";
import { Link } from "react-router-dom";
import CategoryBlock from "../Hisense/categoryBlock";
import langData from "../../lang/data";
import LoadContent from "../../components/LoadContent";
import FromToPage from "../../components/FromToPage";
import BanerSlider from "../../components/BanerSlider";
import PageSeo from "../../components/PageSeo";
import getImageUrl from "../../helpers/getImageUrl";
import {
  listingDescription,
  stripHtml,
  truncateText,
  withBrandSuffix,
} from "../../helpers/seoMeta";

const Samsung = () => {

  const dispatch = useDispatch();
  const { brand, currentLanguage } = useSelector(({ main }) => main);

  useEffect(() => {
    dispatch(getBrandPageInfo("samsung"));
  }, []);

  const pages = useMemo(
    () => [{ label: brand?.brand.name, value: `/samsung`, active: true }],
    [brand?.brand.name]
  );

  const brandName = brand?.brand?.name || "Samsung";
  const seoOverride = useMemo(() => {
    const desc =
      brand?.info?.["text_1_" + currentLanguage] ||
      brand?.info?.["text_2_" + currentLanguage] ||
      brand?.info?.["descr1_" + currentLanguage] ||
      "";
    const slider = brand?.slider1?.[0];
    return {
      title: withBrandSuffix(brandName, currentLanguage),
      description:
        truncateText(stripHtml(desc), 160) ||
        listingDescription(brandName, currentLanguage, "brand"),
      path: "/brand/samsung",
      schemaType: "CollectionPage",
      brandName,
      ogImage:
        getImageUrl(slider?.["image_" + currentLanguage] || slider?.image) ||
        undefined,
      breadcrumbs: [{ name: brandName }],
    };
  }, [brand, brandName, currentLanguage]);

  return (
    <>
      <PageSeo override={seoOverride} />
      <div className="wrapper">
        <FromToPage pages={pages} />
        <BanerSlider
          bannerSliders={brand?.slider1}
          imgStyle={{ maxHeight: "none" }}
        />
        <div className={styles.InfoAboutPage}>
          {!brand ? (
            <LoadContent containerClassName={styles.LoadContentGeneralBanner} />
          ) : (
            <element
              dangerouslySetInnerHTML={{
                __html: brand?.info?.["text_1_" + currentLanguage],
              }}></element>
          )}
        </div>
        <div className={styles.twoBanersBlck}>
          <a href={brand?.baners?.banner_1_href}>
            {!brand ? (
              <LoadContent
                containerClassName={styles.LoadContentTwoBanersBlck}
              />
            ) : (
              <img
                src={
                  process.env.REACT_APP_STORAGE_URL +
                  brand?.baners["baner_1_" + currentLanguage]
                }
                alt={brandName || "VLV"}
              />
            )}
          </a>
          <a href={brand?.baners?.banner_2_href}>
            {!brand ? (
              <LoadContent
                containerClassName={styles.LoadContentTwoBanersBlck}
              />
            ) : (
              <img
                src={
                  process.env.REACT_APP_STORAGE_URL +
                  brand?.baners["baner_2_" + currentLanguage]
                }
                alt={brandName || "VLV"}
              />
            )}
          </a>
        </div>
        <a href={brand?.baners?.banner_3_href}>
          <div className={styles.generalBanner}>
            {!brand ? (
              <LoadContent
                containerClassName={styles.LoadContentGeneralBanner}
              />
            ) : (
              <img
                src={
                  process.env.REACT_APP_STORAGE_URL +
                  brand?.baners["baner_3_" + currentLanguage]
                }
                alt={brandName || "VLV"}
              />
            )}
          </div>
        </a>
      </div>

      <div className="wrapper">
        <div className={styles.titleBlck}>
          <h1 style={{ position: "absolute", width: 1, height: 1, overflow: "hidden", clip: "rect(0 0 0 0)" }}>
            {brandName}
          </h1>
          <h2 className="title">{langData.titles.BestDealProduct[currentLanguage]}</h2>
          <Link
            url={`${
              currentLanguage !== "hy" ? "/" + currentLanguage : ""
            }/brand/samsung/category`}
            className={styles.topPicksProductBtn}>
            {langData.buttons.view_all[currentLanguage]}
          </Link>
        </div>
      </div>
      {/*<ProductsWithSlide productsData={brand?.products_second_slider} />*/}
        <div className="wrapper">
        <CategoryBlock
            myData={brand?.products_second_slider?.slice(0,16)}
            showMoreBtn={false}
            url={false}
        />
        </div>
      <div className="wrapper">
        <BanerSlider
          containerStyle={{
            padding: 0,
            margin: "0px 0px 60px"
          }}
          imgStyle={{
            maxHeight: "none",
            borderRadius: "10px",
          }}
          bannerSliders={brand?.slider2}
        />
        <CategoryBlock
          myData={brand?.products_third_slider?.slice(0,16)}
          showMoreBtn={false}
          url={false}
        />
        <div className={styles.generalBannerSection}>
          <div className={styles.generalBanner}>
            {
                brand?.baners["baner_4_" + currentLanguage] ? (
                  <a href={brand?.baners.banner_4_href}>
                    <img
                      src={
                        process.env.REACT_APP_STORAGE_URL +
                        brand?.baners["baner_4_" + currentLanguage]
                      }
                      alt={brandName || "VLV"}
                    />
                  </a>
                ) : (
                  <LoadContent
                    containerStyle = {{
                      height: "400px",
                    }}
                  />
                )
            }
          </div>
        </div>
        <CategoryBlock
          myData={brand?.products_last_slider?.slice(0,8)}
          showMoreBtn={true}
          url={`${currentLanguage !== "hy" ? "/" + currentLanguage : ""}/brand/samsung/category`}
        />
        <div className={styles.lastInfoBrand}>
          <element
            dangerouslySetInnerHTML={{
              __html: brand?.info?.["text_2_" + currentLanguage],
            }}
          >
          </element>
        </div>
      </div>
    </>
  )
}

export default Samsung;
